import Vue from "vue";
import Notifications from "./notifications/index";

Vue.use(Notifications);
